// extracted by mini-css-extract-plugin
export default {"component":"BonusCondition__component--lc-pYHVL","title":"BonusCondition__title--lc-ckwgr","subtitle":"BonusCondition__subtitle--lc-zviLq"};